<template>
  <div>    
    <div
      class="step__value step__value--margin-bottom"
        v-for="(value, key) in userList"
        :key="key"
      >
        <div class="value" v-if="Object.keys(userList).length > 1">
          {{ getFormattedDate(key.split('|')[0]) }} to {{ getFormattedDate(key.split('|')[1]) }}
          <iconCampingCard v-if="key.split('|')[2] === 'choice'" class="cca-icon"></iconCampingCard>
        </div>
        <div
          class="wrapper d-flex justify-content-between"
          :class="{
            'no-padding': isCompleted,
          }"
        >
          <span>{{ value[0].name }}</span>                      
          <div>
            <div class="label d-flex">                           
              <span class="prices">{{
                value
                  .map(x => x.price)
                  .reduce((sum, el) => sum + el)
                  | currency(campground.currency, language.code)
              }}</span>
            </div>
          </div>
        </div>
      </div>  
  </div>
</template>

<script>
import bookingDataMixin from '@/mixins/bookingDataMixin'
import { mapGetters } from 'vuex';
import iconCampingCard from '@/assets/icons/camping-card.svg'

export default {
  name: "CiAccommodationList",
  components: {
    iconCampingCard,
  },
  mixins: [bookingDataMixin],
  props: {
    userList: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('booking', {
      dates: 'dates',
      isCompleted: 'isCompleted',
    }),
    ...mapGetters('campground', {
      countries: 'countries',
      campground: 'campground',
    }),
  },
};
</script>

<style lang="scss">
@import '../../assets//styles/summary-step';
</style>